import gql from 'graphql-tag';
import React from 'react';
import { Text } from '../../components';
import SearchDropdownSelector from './SearchDropdownSelector';

const GET_VEHICLES = gql`
	query(
		$page: Int!,
		$perPage: Int!,
		$sortBy: String!,
		$sortDirection: Int!,
		$filter: VehiclePageFilter
	) {
		getVehicles(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				id
				name
			}
			count
		}
	}
`;


const VehicleSelector = (props) => {

	const { query, vehicleName } = props;

	return (
		<SearchDropdownSelector
			query={query || GET_VEHICLES}
			renderItem={item => <Text>{ item.name }</Text>}
			renderLabel={item => <Text>{ item.name }</Text>}
			placeholder={vehicleName || 'Select vehicle'}
			{...props}
		/>
	);
};

export default VehicleSelector;
